import React from 'react';

const CosmicLogo = ({ size = 32, style }) => {
  const symbols = ['♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓'];
  
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      style={style}
    >
      <defs>
        <radialGradient id="sun-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="var(--accent-gold)" stopOpacity="1" />
          <stop offset="100%" stopColor="var(--accent-gold)" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Deep Space Background / Base Ring */}
      <circle cx="50" cy="50" r="46" fill="#0A0A1A" stroke="var(--accent-gold)" strokeWidth="1.5" />
      <circle cx="50" cy="50" r="42" stroke="rgba(229, 192, 123, 0.3)" strokeWidth="0.5" strokeDasharray="2 4" />

      {/* 12 Zodiac Symbols */}
      {symbols.map((symbol, i) => {
        const angle = (i * 30) * (Math.PI / 180);
        const radius = 35;
        const x = 50 + radius * Math.sin(angle);
        const y = 50 - radius * Math.cos(angle);
        return (
          <g key={i}>
            {/* Theme color background for each symbol */}
            <circle cx={x} cy={y} r="4.5" fill="var(--accent-gold)" />
            <text 
              x={x} 
              y={y} 
              fill="#0A0A1A" 
              fontSize="6" 
              fontWeight="bold"
              textAnchor="middle" 
              dominantBaseline="central"
              style={{ fontFamily: 'sans-serif' }}
            >
              {/* \uFE0E forces text rendering instead of Apple's purple emoji */}
              {symbol + '\uFE0E'}
            </text>
          </g>
        );
      })}

      {/* Inner Mandala / Navagraha Orbits */}
      <circle cx="50" cy="50" r="25" stroke="var(--accent-gold)" strokeWidth="1" strokeOpacity="0.8" />
      
      {/* 8-Pointed Star (Lotus/Directional Motif) */}
      <path 
        d="M 50 25 L 53 47 L 75 50 L 53 53 L 50 75 L 47 53 L 25 50 L 47 47 Z" 
        fill="rgba(229, 192, 123, 0.15)" 
        stroke="var(--accent-gold)" 
        strokeWidth="1" 
      />

      {/* Clock Hands (Time aspect) */}
      <line x1="50" y1="50" x2="50" y2="30" stroke="#FFF" strokeWidth="2" strokeLinecap="round" />
      <line x1="50" y1="50" x2="65" y2="50" stroke="#FFF" strokeWidth="1.5" strokeLinecap="round" />
      
      {/* Central Sun / Bindu */}
      <circle cx="50" cy="50" r="12" fill="url(#sun-glow)" />
      <circle cx="50" cy="50" r="4" fill="#FFF" />

      {/* Planetary dots on orbits */}
      <circle cx="68" cy="32" r="1.5" fill="#FFF" />
      <circle cx="32" cy="68" r="1" fill="#FFF" />
      <circle cx="30" cy="40" r="2" fill="#D4AF37" />
    </svg>
  );
};

export default CosmicLogo;
